import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { firstMittReducer } from 'src/features/atoms/glove/japan/slice/first'
import { State, PartialAction } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { useRouter } from 'next/router'
import { atomsBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'

const AtomsFirst: React.FC = () => {
  const { t } = useLocale()
  const router = useRouter()
  const models = atomsBaseModel(t, router)
  const [state, dispatch] = React.useReducer(firstMittReducer, t.INITIAL_STATE_F_MITT) as [State, React.Dispatch<PartialAction>]
  const [figurePanelNum, setFigurePanelNum] = React.useState(1)
  const handleFigurePanelNum = (_: any, newValue: number) => setFigurePanelNum(newValue)
  return (
    <OrderPageTemplate
      breadcrumbTrail={`${t.SOFT} / ATOMS / ${t.FIRST_BASEMAN}`}
      brand={'atoms'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} kinds={{ label: '軟式', value: 'soft' }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default AtomsFirst
